// External
import _ from "lodash";

// Utils
import { exportData } from "Utils/ExportData";

/**
 * Generic utility function to generate files from FeedListv2 table data
 * @param {Object} params
 * @param {Array} params.feedData - Array of row data objects
 * @param {Array} params.columnList - Array of column configuration objects
 * @param {String} params.fileName - Complete filename for the file (without extension)
 * @param {String} params.outputFormat - Output format: "CSV" or "XLSX"
 * @returns {Object} - { success: boolean, error?: any }
 */
export const generateFileFromTableData = ({
  feedData,
  columnList,
  fileName,
  outputFormat,
}) => {
  try {
    // Filter only visible columns
    const visibleColumns = _.filter(columnList, column =>
      _.get(column, "visible", false)
    );

    // Extract field labels from visible columns
    const fieldLabels = _.map(visibleColumns, column => _.get(column, "label"));

    // Prepare data for export - create mapping from field IDs to labels for headers
    const fileData = _.map(feedData, rowData => {
      const row = {};
      _.forEach(visibleColumns, column => {
        const fieldId = _.get(column, "id");
        const fieldLabel = _.get(column, "label");
        // Get value and handle empty cells
        const value = _.get(rowData, fieldId, "");
        row[fieldLabel] = _.trim(value) || "";
      });
      return row;
    });

    // Export using the existing exportData utility
    exportData({
      data: {
        data: fileData,
        fields: fieldLabels, // Use labels as both keys and headers
        filename: fileName,
      },
      outputFormat: outputFormat,
      fileName: fileName,
    });

    return { success: true };
  } catch (error) {
    return { success: false, error };
  }
};
